<template>
  <el-dialog class="radish-dia" title="请填写公司和年份" top="70px" :modal="false" :close-on-click-modal="false" :visible.sync="dialogVisible">
    <div v-if="dialogVisible">
      <el-select v-if="companies.length > 0" v-model="cid" filterable size="mini" placeholder="选择公司(可搜索)">
        <el-option v-for="item in companies" :key="item._id" :label="item['简称']" :value="item._id"></el-option>
      </el-select>
      <el-input v-model="year" size="mini" placeholder="填写年份" style="width:200px"></el-input>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button size="mini" type="primary" @click="handleConfirm">确定</el-button>
    </span>
  </el-dialog>
</template>
<script>
export default {
  props: {
    onConfirm: {
      type: Function,
      default: function() {},
    },
  },
  data: function() {
    return {
      dialogVisible: false,
      companies: [],
      cid: '',
      year: '',
    }
  },
  async created() {
    const res = await app.service('company').getCompanySimpleList()
    console.log(res)
    if (res.status === 'success') {
      this.companies = res.data
    }
  },
  methods: {
    show: function() {
      this.cid = ''
      this.year = ''
      this.dialogVisible = true
    },
    handleConfirm: async function() {
      if (!this.cid) {
        return this.$message.warning('请选择公司')
      }
      if (!this.year || !/^20\d{2}$/.test(this.year)) {
        return this.$message.warning('请填写正确年份')
      }
      this.onConfirm(this.cid, this.year)
      this.dialogVisible = false
    },
  },
}
</script>
